import React from 'react';

const SessionExpired: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-10 text-center animate-fade-in">
        <div className="mb-8 flex justify-center">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center animate-pulse">
            <svg
              className="w-10 h-10 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
        </div>

        <h1 className="text-3xl font-extrabold text-gray-900 mb-4 tracking-tight">
          Session Expired
        </h1>

        <div className="h-1 w-20 bg-red-500 mx-auto mb-6 rounded-full" />

        <p className="text-gray-600 text-lg leading-relaxed">
          Your session has timed out due to an expired security token.
          Please restart the booking process from your practice's link.
        </p>

        <div className="mt-10 pt-8 border-t border-gray-100 italic text-sm text-gray-400">
          For security reasons, we've ended your current session.
        </div>
      </div>
    </div>
  );
};

export default SessionExpired;
